// ** React Imports
import { useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import Swal from 'sweetalert2'
import axios from 'axios'
import Switch from '@mui/material/Switch';
import { AddCompetency } from "../Competency/Modal/AddCompetency"
import { IconButton, Tooltip } from '@mui/material';
import { Add, Delete, Edit } from '@mui/icons-material';
import Question from "./Question";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CompetenyClone from '../Competency/Modal/CompetenyClone';

export const AllCompetencyList = ({competencies, getList, ...rest}) => {
  const [show, setShow] = useState(false);
  const [popupType, setPopupType] = useState("Edit");
  const [editId, setEditId] = useState(0);
  const [showClone, setShowClone] = useState(false);
    
  const [accordion, setAccordion] = useState({});
  const [isChange, setIsChange] = useState(false)
  const [competencyId, setcompetencyId] = useState(false)

  const location = useLocation();
  const current_path = location.pathname;

  let data = competencies;
  if(current_path === '/survey_templates'){
    data = competencies.survey_competencies;
  }
  
  const handleEdit = (id) => {
    setEditId(id);
    setPopupType('Edit');
    setShow(true);
  }

  const handleCompetencyStatus = (e, competencyId) => {
    var status = e.target.checked === true ? '1' : '0';
    axios.put(`api/competencies/updateStatus?id=${competencyId}`, {status}).then(res => {})
    .catch(err => {})
  }

  const handleCompetencyDelete = (competencyId) => {
    Swal.fire({
      title: 'Are you sure you want to delete?',
      showCancelButton: true,
      confirmButtonColor: '#45a7c4',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) { 
          axios.delete(`/api/competencies/delete?id=${competencyId}`).then((res) =>{
              if(res.data.success){                             
                  Swal.fire('Deleted!', '', 'success').then(result => { 
                      getList();
                  })
              }
              else{
                Swal.fire(res.data.message, '', 'info')
              } 
              
          }).catch((error) => {
              console.log(error);                     
              Swal.fire(error.message, '', 'info')           
          });
        } else if (result.isDenied) {
          Swal.fire('Cancelled!', '', 'info')
        }
    }) 
  }

  const handleAccordionChange = (key) => {
    if(accordion && accordion[key]){
        accordion[key] = !accordion[key]
    }
    else{
        accordion[key] = true
    }
    setIsChange((prev) => !prev);
    // Get the accordion button element
    const accordionButton = document.querySelector(`[data-key="${key}"]`);
    // Toggle the active class on the accordion button
    accordionButton.classList.toggle('active');

  }

  const handleCompetencyClone = (id) => {
    console.log("id", id)
    setShowClone(true)
    setcompetencyId(id)
  }

  useEffect(() => {
    console.log("competencyId", competencyId)
  }, [competencyId])

  return (
    <>
    <div className="accordion" id="accordionExample">
        {data.map((competency) => (
            <div className="card accordion-item" key={competency.id}>
                <h2 className="accordion-header d-flex align-items-center" id="headingOne">
                    <button type="button" onClick={() => handleAccordionChange("accordion"+competency.id)} className="accordion-button collapsed" data-bs-toggle="collapse" data-bs-target={"#accordion"+competency.id} aria-expanded="false" aria-controls={"accordion"+competency.id} data-key={"accordion"+competency.id}>
                        {competency.name ? competency.name : competency.competency.name}
                    </button>
                    <div className="d-flex align-items-center">
                        {/* {current_path === '/competencies' && authUserId === competency.userId ?
                            <Switch className="Rj-toggle" color="info" onChange={(e) => handleCompetencyStatus(e, competency.id)} defaultChecked={competency.status === '1' ? true : false}/>  : ""
                        } */}
                        {/* <Tooltip 
                            onClick={() => handleCompetencyClone(competency.id)} 
                            title="Competency Clone" 
                            size='small' 
                            className='icon icon-sm icon-primary me-3'
                        >
                            <IconButton>
                                <ContentCopyIcon />
                            </IconButton>
                        </Tooltip> */}
                        <Link to={"/add_questions/"+competency.id} className="lineHeight-1px">
                            <Tooltip title="Add Questions" size='small' className='icon icon-sm icon-theme me-3'>
                                <IconButton>
                                    <Add />
                                </IconButton>
                            </Tooltip>
                        </Link>
                        <Tooltip onClick={() => handleEdit(competency.id)} title="Edit Competency" size='small' className='icon icon-sm icon-secondary me-3'>
                            <IconButton>
                                <Edit />
                            </IconButton>
                        </Tooltip>
                        <Tooltip onClick={() => handleCompetencyDelete(competency.id)} title="Delete Competency" size='small' className='icon icon-sm icon-primary me-3'>
                            <IconButton>
                                <Delete />
                            </IconButton>
                        </Tooltip> 
                    </div>
                </h2>

                <div id={"accordion"+competency.id} className={accordion && accordion["accordion"+competency.id] ? 'accordion-collapse collapse show' : 'accordion-collapse collapse'} data-bs-parent="#accordionExample">
                    <div className="accordion-body">
                        <div className="table-responsive">
                            <table className="table ">
                                <thead>
                                    <tr>
                                        <th>Question Type</th>
                                        <th>Question</th>
                                        <th>Status</th>
                                    </tr>
                                </thead>
                                <tbody className="table-border-bottom-0">
                                    <Question  
                                        questions={competency.survey_competency_questions ? competency.survey_competency_questions : competency.questions} 
                                        surveyId={competencies.id ? competencies.id : 0} 
                                        competencyId={competency.competencyId?competency.competencyId:competency.id}
                                        getList={getList}
                                    />
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        ))}
    </div>
    <AddCompetency type={popupType} show={show} setShow={setShow} getList={getList} editId={editId} setEditId={setEditId}/>
    <CompetenyClone show={showClone} setShow={setShowClone} getList={getList} competencyId={competencyId}/>
    </>
    
  )
}
